
























import { computed, defineComponent, ref } from '@vue/composition-api';
import { useRoute } from '@/hooks/use-route';
import { useStampStore } from '@/store/stamp';
import { language } from '@tencent/ppd-base-libs';
import { storeToRefs } from 'pinia';
import Button from '@/components/common/button.vue';
import SvgIcon from '../common/svg-icon.vue';
import AddSubtractNum from '@/components/add-subtract-num/index.vue';
import DonationBtn from '@/components/donation-btn/index.vue';
import { biClick } from '@tencent/fit-bi-sdk';

export default defineComponent({
  name: 'NgoStampNgoItem',
  props: {
    item: {
      reuqired: true,
      type: Object,
      default: () => ({ key: '' }),
    },
    userDonationStatus: Number,
  },
  components: { Button, SvgIcon, AddSubtractNum, DonationBtn },
  setup(props, { emit }) {
    const stampStore = useStampStore(); // store
    const { userStampInfo } = storeToRefs(stampStore);
    const lang = ref(language.getLanguage());

    const addSubtractNum = ref<InstanceType<typeof AddSubtractNum> | null>(null);
    const name = computed(() => (lang.value === 'en' ? props.item.enName : props.item.name));
    const desc = computed(() => (lang.value === 'en' ? props.item.descEn : props.item.desc));
    const biExt = {
      fngo_item_name: props.item.name,
    };
    // 路由
    const route = useRoute();
    // 跳转详情
    const handleGoDetail = (key: string) => {
      route.router.push(`/ngo/${key}`);
      biClick('ngo-item.item_click|捐赠项目点击', biExt);
    };
    const currentNum = ref(1);
    const maxNum = computed(() => userStampInfo.value.intervalAvailableCnt || 1);
    // 语言
    const isEn = ref(false);
    isEn.value = language.isEn();

    return {
      // 是否英文
      lang,
      isEn,
      handleGoDetail,
      maxNum,
      name,
      desc,
      biExt,
      currentNum,
      addSubtractNum,
      numChange(num) {
        props.item.donateCount = num;
      },
      donationComplete() {
        addSubtractNum.value?.setCurrentNum(1);
      },
      donationSucc(ngo) {
        emit('donationSucc', ngo);
      },
    };
  },
});
